/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
} from '../models/index';

export interface GetProcessedImageRequest {
    fileId: string;
    width?: number;
    height?: number;
    aspectRatio?: number;
    smartCrop?: GetProcessedImageSmartCropEnum;
}

/**
 * 
 */
export class ImagesApi extends runtime.BaseAPI {

    /**
     * Gets a processed image with optional scaling and cropping, served as WebP format
     */
    async getProcessedImageRaw(requestParameters: GetProcessedImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
            throw new runtime.RequiredError('fileId','Required parameter requestParameters.fileId was null or undefined when calling getProcessedImage.');
        }

        const queryParameters: any = {};

        if (requestParameters.width !== undefined) {
            queryParameters['width'] = requestParameters.width;
        }

        if (requestParameters.height !== undefined) {
            queryParameters['height'] = requestParameters.height;
        }

        if (requestParameters.aspectRatio !== undefined) {
            queryParameters['aspectRatio'] = requestParameters.aspectRatio;
        }

        if (requestParameters.smartCrop !== undefined) {
            queryParameters['smartCrop'] = requestParameters.smartCrop;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/images/{fileId}`.replace(`{${"fileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.BlobApiResponse(response);
    }

    /**
     * Gets a processed image with optional scaling and cropping, served as WebP format
     */
    async getProcessedImage(requestParameters: GetProcessedImageRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getProcessedImageRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Blob>(response, errorHandlers);
    }

}

/**
 * @export
 */
export const GetProcessedImageSmartCropEnum = {
    Centre: 'Centre',
    Attention: 'Attention',
    Entropy: 'Entropy',
    High: 'High',
    Low: 'Low'
} as const;
export type GetProcessedImageSmartCropEnum = typeof GetProcessedImageSmartCropEnum[keyof typeof GetProcessedImageSmartCropEnum];
